import { NodeType } from '../constants/NodeType'
import { IInstagramNode, INode } from '../nodes/nodeInterfaces'

export const isInstagramNode = (node: INode): node is IInstagramNode => {
  return node.nodeType === NodeType.INSTAGRAM
}
